module.exports = __webpack_public_path__ + "static/media/3rd_banner_item2.086b935d.png";